export default __webpack_public_path__ + "static/media/searching1.ff3c4c92.gif";